module.exports = __webpack_public_path__ + "assets/images/offlineMaps-ee2a03d9b72a7ffe52b96d6333de710c.png";